import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useOutsideClick } from '../../hooks/index.js';
import { StyledPopover, StyledPopoverContainer } from './index.styles.js';
import { useEscapeKey } from './utils/use-esc-key-listener.js';
import { usePopoverPosition } from './utils/use-popover-position.js';
import { Transition } from 'react-transition-group';
import { useFocusTrap } from './utils/use-focus-trap.js';
import { useScroll } from './utils/use-scroll.js';
export const Popover = ({ triggerElement, content, open, onClose, id, documentAnchor, withTip, alignment = 'center', placement = 'bottom', 'data-testid': dataTestId }) => {
    const popoverId = id;
    const bubbleRef = useRef(null);
    const triggerRef = useRef(null);
    const [isClient, setIsClient] = useState(false);
    useFocusTrap({
        open,
        ref: bubbleRef,
        triggerRef
    });
    useOutsideClick([bubbleRef, triggerRef], onClose);
    useEscapeKey(onClose);
    usePopoverPosition({
        ref: bubbleRef,
        alignment,
        placement,
        open,
        triggerRef,
        withTip
    });
    useScroll({ open, callback: onClose });
    const triggerProps = {
        'aria-expanded': open,
        'aria-haspopup': 'dialog',
        'aria-controls': popoverId,
        ref: triggerRef
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    if (!isClient) {
        return null;
    }
    return (React.createElement(StyledPopoverContainer, { "data-testid": dataTestId },
        React.cloneElement(triggerElement, triggerProps),
        React.createElement(Transition, { nodeRef: bubbleRef, in: open, timeout: 125, unmountOnExit: true }, (state) => createPortal(React.createElement(StyledPopover, { withTip: withTip, id: popoverId, role: "dialog", ref: bubbleRef, "aria-hidden": !open, state: state, placement: placement }, content), documentAnchor || document.body))));
};
//# sourceMappingURL=index.js.map